import { JSX } from 'react'

import { IconProps } from '../../icon'

const ChevronDown: (props: IconProps) => JSX.Element = ({
  dataTestId,
  height,
  id,
  stroke,
  title,
  width,
}: IconProps) => (
  <svg
    data-testid={dataTestId}
    fill='none'
    height={height || 48}
    id={id}
    stroke={stroke}
    viewBox='0 0 48 48'
    width={width || 48}
    xmlns='http://www.w3.org/2000/svg'
  >
    <title>{title}</title>
    <g clipPath='url(#clip0_46_121)'>
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M13.9603 18.4603C14.5739 17.8466 15.5689 17.8466 16.1826 18.4603L24.5 26.7777L32.8174 18.4603C33.4311 17.8466 34.4261 17.8466 35.0397 18.4603C35.6534 19.0739 35.6534 20.0689 35.0397 20.6826L25.6112 30.1112C24.9975 30.7248 24.0025 30.7248 23.3888 30.1112L13.9603 20.6826C13.3466 20.0689 13.3466 19.0739 13.9603 18.4603Z'
        fill='black'
      />
    </g>
    <defs>
      <clipPath id='clip0_46_121'>
        <rect width='48' height='48' fill='white' transform='translate(0.5)' />
      </clipPath>
    </defs>
  </svg>
)

export default ChevronDown
